import styled from "styled-components/macro";
import { buttonReset, focusVisible } from "../../styles/a11y";

export const StyledContainer = styled.div`
  position: ${({ $surface }) => ($surface === "section" ? "relative" : "absolute")};
  top: ${({ $surface }) => ($surface === "section" ? "auto" : "0")};
  z-index: ${({ $surface }) => ($surface === "section" ? "auto" : "10000")};
  background: ${({ $surface }) => ($surface === "section" ? "transparent" : "var(--menu-color)")};
  padding: ${({ $surface }) => ($surface === "section" ? "0" : "14px 20px 12px 20px")};
  width: ${({ $surface }) => ($surface === "section" ? "100%" : "330px")};
  text-align: left;
  border-radius: ${({ $surface }) => ($surface === "section" ? "0" : "20px")};
  box-shadow: ${({ $surface }) => ($surface === "section" ? "none" : "var(--default-drop-shadow)")};
  color: var(--grey-0);
  max-height: ${({ $surface }) => ($surface === "section" ? "none" : "610px")};
  left: ${({ $surface }) => ($surface === "section" ? "auto" : "0")};

  h3 {
    font-weight: 500;
    font-family: Inter;
    margin-top: -5px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .menu-back-button {
      ${buttonReset}
      ${focusVisible}
      font-family: Inter;
      color: var(--grey-0);
      background: var(--menu-color);
      position: relative;
      display: inline-block;
      line-height: 0;
      margin-left: -5px !important;
      margin-right: 12px !important;
      svg {
        path {
          stroke: var(--grey-0);
        }
      }
    }
  }

  .length-settings,
  .mode-settings {
    display: flex;
    margin-bottom: 24px;
    z-index: 20001;
    justify-content: space-between;
    ${({ $surface }) =>
      $surface === "section" &&
      `
        flex-direction: column;
        gap: 20px;
      `}
    .length-select,
    .cards-select,
    .mode-select {
      display: inline-block;
    }

    h2 {
      font-size: 13px;
    }

    h3 {
      margin-bottom: 5px;
    }

    .select svg path {
      fill: var(--grey-0);
    }

    .cards-select {
      z-index: 20002;
      width: ${({ $surface }) => ($surface === "section" ? "auto" : undefined)};

      .select {
        width: 60px;
        svg {
          path {
            fill: var(--grey-0);
          }
        }
      }
    }

    .length-select {
      z-index: 20002;
      width: ${({ $surface }) => ($surface === "section" ? "auto" : undefined)};

      h3 {
        position: relative;
      }

      .select {
        width: 140px;
        svg {
          path {
            fill: var(--grey-0);
          }
        }
      }
    }

    .mode-select {
      z-index: 20001;
      width: ${({ $surface }) => ($surface === "section" ? "fit-content" : "100%")};
      max-width: 100%;
      .labels {
        font-size: 16px;
      }
      ${({ $surface }) =>
        $surface === "section" &&
        `
        button.use-component-styles {
          width: auto;
          min-width: 160px;
          max-width: 100%;
        }
      `}
      .select {
        width: ${({ $surface }) => ($surface === "section" ? "auto" : "100%")};

        [class$="menu"]::after {
          content: "";
          border-radius: 10px;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 60px;
          pointer-events: none;
        }
      }
    }
  }

  .select [class$="menu"]::after {
    content: "";
    border-radius: 10px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    pointer-events: none;
  }

  .select [class$="menu"].hide-fade::after {
    background: none;
  }

  .memory-enabled-toggle {
    float: right;
    div {
      margin-right: 2px;
    }
  }

  .memory {
    position: relative;
    z-index: 10000;

    .placeholder {
      position: absolute;
      font-family: Inter;
      font-size: 16px;
      color: var(--grey-1);
      top: 0;
      left: 0;
      line-height: 130%;
      padding: 14px;
      z-index: 0;
    }

    textarea {
      position: relative;
      width: calc(100% - 24px);
      border-radius: 8px;
      border-color: var(--grey-2);
      border-width: 2px;
      padding: 10px;
      font-family: Inter;
      font-size: 16px;
      height: 130px;
      z-index: 10000;
      background: transparent;
      color: var(--grey-0);
      resize: none;

      &:focus {
        border-color: var(--primary-cta);
      }

      &:disabled {
        color: var(--gray-2);
        opacity: 0.4;
      }
    }
  }

  .disclaimer {
    display: block;
    font-size: 12px;
    padding-left: 1px;
    font-weight: 500;
    color: var(--grey-1);
  }

  .warning {
    float: right;
    margin-top: -2em;
    font-size: 11px;
    color: var(--grey-0);
  }

  .divider {
    border-bottom: ${({ $surface }) => ($surface === "section" ? "1px solid var(--grey-3)" : "2px solid var(--divider)")};
    width: ${({ $surface }) => ($surface === "section" ? "100%" : "calc(100% + 40px)")};
    position: relative;
    left: ${({ $surface }) => ($surface === "section" ? "0" : "-20px")};
    margin-bottom: 20px;
  }
`;
